import React, { useEffect, useState } from 'react';
import {
  Descriptions,
  Badge,
  Layout,
  Row,
  Col,
  Card,
  Button,
  Spin,
  Input,
} from 'antd';
import './documents.css';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import {
  ConditionsRequest,
  CrrencySymbols,
  SaleOrderDetailDto,
  SaleOrderDetailViewInfoDTO,
} from '@gtpl/shared-models/sale-management';
import {
  FactoriesInput,
  PlantInvoiceDetailsModel,
  PlantInvoiceDetailsRequest,
  UnitsOfWeightInput,
} from '@gtpl/shared-models/sale-management';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { componentRequest, ExporterDataInput } from '@gtpl/shared-models/logistics';
import { GlobalStatus, ModeOfExportEnum, UomEnum } from '@gtpl/shared-models/common-models';
import { useLocation } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { PrinterOutlined } from '@ant-design/icons';
let converter = require('number-to-words');
import { numberToWords } from 'amount-to-words';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import moment from 'moment';
import { ToWords } from 'to-words';
import stampImage from './stamp.png';
import signature from './signature.png';
import { GlobalPriceChartService } from '@gtpl/shared-services/masters';
import { log } from 'util';
import { ContainerRegisterService } from '@gtpl/shared-services/logistics';

// const { ToWords } = require('to-words');
const toWords = new ToWords({
  localeCode: 'en-US',
});
/* eslint-disable-next-line */
export interface CommonInvoiceProps {
  saleOrderId: number;
}

export function CommonInvoice(props: CommonInvoiceProps) {
  let location = useLocation();
  const salOrderService = new SaleOrderService();
  const [plantDetails, setPlantDetails] = useState<PlantInvoiceDetailsModel>();
  const soId = location.state;
  const [remarksData, setRemarksData] = useState<string>(undefined);
  const { TextArea } = Input;
  const defaultDeclaration =
    'We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct';
  const globalPriceService = new GlobalPriceChartService();
  const [mainData, setMainData] = useState<any[]>([]);
  const [conditionRes, setConditionRes] = useState([]);
const [mpfDetails,setMpfDetails]=useState<any>()
  const [tariffDetails,setTariffDetails]=useState<any>()
  const [cvdDetails,setCvdDetails]=useState<any>()
  const containerRegisterService = new ContainerRegisterService();

  let totalCases = 0;
  let netWeightInKgs = 0;
  let netWeightInLbs = 0;

  let totalAmount = 0;
  let itemsTotalAmount = 0;
  let totalLbWeight = 0;
  let totalGrossWeight = 0;
  let FOBInRs = 0;
  let grossWeightInKg;
  let frozenWeightInKg;
  let totalAmnt = 0;
  let newUnitPrice;
  let newTotalAmount = 0;
  let antiDumping;
  let fob;
  let subTotal;
  let cvdVal;
 let mpfVal;
  let tariffVal;

  useEffect(() => {
    getAntiDumpingPrice();
  }, []);

  const getAntiDumpingPrice = () => {
    globalPriceService
      .getAntiDumpingPrice()
      .then((res) => {
        if (res.status) {
          setMainData(res.data);
        } else {
          setMainData([]);
        }
      })
      .catch((err) => {
        setMainData([]);
      });
  };
  const printOrder = () => {
    const printableElements = document.getElementById('printme').innerHTML;
    const orderHTML =
      '<html><head><title></title></head><body>' +
      printableElements +
      '</body></html>';
    const oldPage = document.body.innerHTML;
    document.body.innerHTML = orderHTML;
    // document.body.innerHTML = oldPage
    window.print();
  };
   const getCvdValue = (cvdRates, invoiceDate) => {
     // console.log(cvdRates,'cvdratesssssssss');
     
     if (!cvdRates?.length || !invoiceDate) return null;
   
     const invoiceTime = new Date(invoiceDate).getTime();
   
     // Find the matching CVD record based on invoiceDate
     let selectedCvd = cvdRates?.find(({ effective_from, created_at }) => {
       const effectiveTime = new Date(effective_from).getTime();
       const createdTime = new Date(created_at).getTime();
       // console.log(effectiveTime,'effectiveTime');
       // console.log(createdTime,'createdTime');
       return invoiceTime >= effectiveTime && invoiceTime <= createdTime;
     });
   // console.log(selectedCvd,'!selectedCvd');
   
     // If no match found, select the one with the latest created_at
     if (!selectedCvd) {
       // console.log(cvdRates?.reduce((latest, current) =>
       //   new Date(current?.created_at) > new Date(latest.created_at) ? current : latest
       // , cvdRates[0]),'oooooooooo');
       
       selectedCvd = cvdRates?.[0];
     }
   // console.log(selectedCvd,'seeeeeeee');
   
     return selectedCvd ? Number(selectedCvd?.price) : 0;
   };
   
 
   const getData = (saleOrderId) => {
     const reqObj = new PlantInvoiceDetailsRequest(1);
     salOrderService
       .getPlantInvoiceDetails(new PlantInvoiceDetailsRequest(saleOrderId))
       .then((res) => {
         if (res.status) {
           setPlantDetails(res.data);
           const invoiceDate = res.data.invoiceDate;
           const fetchComponentRate = (component, setter) => {
           const req = new componentRequest(component);
           containerRegisterService.getCvdRatesForCustomsInvoice(req).then((cvdRes) => {
             if (cvdRes.status) {
               const filteredRates = cvdRes.data.filter(e => e.component === component);
               const value = getCvdValue(filteredRates, invoiceDate);
               setter(value);
             }
           });
         };
 
         // Fetching all 3 components individually
         fetchComponentRate("CVD", setCvdDetails);
         fetchComponentRate("MPF & HARBOUR MAINTAINCE", setMpfDetails);
         fetchComponentRate("RECIPROCAL TARIFF", setTariffDetails);
 
 
 
           res.data.gradeInfo.map((res) =>
             res.info.filter((val) => val.itemCode != null)
           );
           const request = new ConditionsRequest();
           request.country = res.data.country;
           request.frozenWeight = res.data.frozenWeight;
           request.grossWeight = res.data.grossWeight;
           request.notifyParty = res.data.notifyPartyOne;
           request.deliveryTerms = res.data.deliveryTerms;
           request.buyer = res.data.endCustomerName;
           request.buyerAddress = plantDetails?.saleOrderItems[0]?.buyerAddress;
           request.deliveryAddress =
             plantDetails?.saleOrderItems[0]?.deliveryaddress;
           // request.netWeight=
           salOrderService.getConditionsBasedLogistics(request).then((res) => {
             if (res.status) {
               setConditionRes(res.data);
             }
           });
         } else {
           if (res.intlCode) {
             setPlantDetails(undefined);
             AlertMessages.getErrorMessage(res.internalMessage);
           } else {
             AlertMessages.getErrorMessage(res.internalMessage);
           }
         }
       })
       .catch((err) => {
         AlertMessages.getErrorMessage(err.message);
         setPlantDetails(undefined);
       });
   };


  useEffect(() => {
    // setRemarksData("text");
    if (props.saleOrderId) {
      getData(props.saleOrderId);
    }
    // window.print()
  }, [props.saleOrderId]);

  let exporterDetails = ExporterDataInput;

  // Determine the ID to use based on the `isInvoiced` value
  const idToFind = plantDetails?.isInvoiced === "YES" 
    ? plantDetails?.exporterId 
    : plantDetails?.unitId;
  
  // Find the corresponding exporter data
  const exporterData = exporterDetails.find(item => item.value === idToFind);
  
  const processingId= plantDetails?.processingUnit;

  const processingData = exporterDetails.find(
    (item) => item.value === processingId
  );
      let exporterPlant = FactoriesInput;
    const exportersPlant = exporterPlant.find(
      (item) => item.id == processingId
    );
  let spanVal = 0;
  let adjustSpan = 0;
  const rowSpanValue = Math.round(plantDetails?.gradeInfo?.length / 2);
  if (
    plantDetails?.gradeInfo?.length % 2 !== 0 &&
    plantDetails?.gradeInfo?.length > 1
  ) {

    spanVal = Math.round(plantDetails?.gradeInfo?.length / 2);
    adjustSpan = Math.round(plantDetails?.gradeInfo?.length / 2) - 1;
  } else if (plantDetails?.gradeInfo?.length === 1) {
    spanVal = 1;

    adjustSpan = 1;
  } else {
    spanVal = Math.round(plantDetails?.gradeInfo?.length / 2);
    adjustSpan = Math.round(plantDetails?.gradeInfo?.length / 2);
  }

  let unitInput = FactoriesInput;
  const unitsData = FactoriesInput.find(
    (item) => item.id == plantDetails?.unitId
  );
  const tableData = () => {
    const tableDataArray = [];
    for (const data of plantDetails?.saleOrderItems) {
      const tableDataArray = data;
    }
  };

  const freightCharges = plantDetails?.freightCharges ? plantDetails?.freightCharges : 0;
const antiDumpingValue = antiDumping ? Number(antiDumping).toFixed(2) : 0;
console.log(antiDumpingValue,"antiDumpingValue")

const fobValue = fob ? Number(fob).toFixed(2) : 0;
console.log(fobValue,"fobValue")

const firstTdValue = plantDetails?.saleOrderItems[0]?.currencyDetails + ' : ' + freightCharges;
console.log(firstTdValue,"firstTdValue")

const thirdTdValue = Number(freightCharges) - Number(antiDumpingValue);
console.log(thirdTdValue,"thirdTdValue")


  // return 'test';
  // const print = () => {
  //   var content = document.getElementById("divcontents");
  //   var pri = document.getElementById("ifmcontentstoprint").contentWindow;
  //   pri.document.open();
  //   pri.document.write(content.innerHTML);
  //   pri.document.close();
  //   pri.focus();
  //   pri.print();
  // }
  const handleRemarks = (value) => {
    setRemarksData(value);
  };
  let hasNumber = /\d/;
  let normalOrder = hasNumber.test(plantDetails?.buyerPoNo);
  let lotRefString = '';
  let lotNo = '';
  let RefNo = '';
  if (normalOrder) {
    if (plantDetails?.lotCode) {
      lotNo = 'LOT NO. ' + plantDetails?.lotCode + ', ';
    }
    if (plantDetails?.buyerPoNo) {
      RefNo = 'REF NO. ' + plantDetails?.buyerPoNo;
    }
    lotRefString = lotNo + RefNo;
  }

  let totalContainersRowSpan = 0;
  let containerProductLevelRowSpan = new Map<number, number>(); // map of array_index_of_product => no of rows in it
  plantDetails?.gradeInfo?.forEach((g, prodIndex) => {
    let prodRowCount = 0;
    g?.info?.forEach((r, i) => {
      // incre,ent the total row span for every record
      totalContainersRowSpan++;
      prodRowCount++;
    });
    containerProductLevelRowSpan.set(prodIndex, prodRowCount);
  });
  const copiedContainerRowSpan = totalContainersRowSpan;

  const sealNoRowPortionSpan = totalContainersRowSpan / 2;

  const lhsContent = [];
  const rhsContent = [];

  function ConstrunctLhsContent(plantDetails: PlantInvoiceDetailsModel) {
    lhsContent.push(
      <>
        <b>Exporter:</b> 
        <br />
        <h4>
          {exporterData?.company ? exporterData?.company : ''}
          <br />
          {exporterData?.addressOne ? exporterData?.addressOne + ',' : ''}
          <br />
          {exporterData?.addressTwo
            ? exporterData?.addressTwo + ' - ' + exporterData?.postalCode
            : ''}
          <br />
          {exporterData?.state + ', ' + exporterData?.country}
          <br />
       
          {exporterData?.phoneNumber? 
          <>PHONE:{exporterData?.phoneNumber}
          <br />
          </>:''}
          {exporterData?.faxNo!=null? <>FAX:{exporterData?.faxNo}</>:''}
          <br/>
          GSTIN: {exporterData?.GSTNumber}
          <br />
          USFDA REGN NO: {exporterData?.usfdaRegNo}
        </h4>
      </>
    );

    {
      plantDetails?.consigneeAddress != undefined ||
      plantDetails?.consignee != null ? (
        lhsContent.push(
          <>
            <b>
              <u>Consignee:</u>
            </b>
            <br />
            {plantDetails?.consignee}
            {plantDetails?.consignee ? ':' : ''}
            <br />
            {plantDetails?.consigneeAddress?.split(',')}
            <br />
            {plantDetails?.country ? plantDetails?.country : ''}

          </>
        )
      ) : (
        <></>
      );
    }

    {
      conditionRes?.[0]?.importerDetails === true ? (
        lhsContent.push(
          <>
          <b>Importer of record:</b>
          <div><h4>
            {exporterData?.company ? exporterData?.company : ''}
          </h4></div>
          <div>{exporterData?.addressOne + ','}</div>
         <div> {exporterData?.addressTwo
            ? exporterData?.addressTwo + ' - ' + exporterData?.postalCode
            : ''}</div>
          <div> {exporterData?.state + ', ' + exporterData?.country}
          </div>
          PHONE:{exporterData?.phoneNumber}
          <br />
          {exporterData?.faxNo!=null? <div>FAX:{exporterData?.faxNo}</div>:''}
          <br/>
          <b>Import On Record: </b>
          {plantDetails?.country === 'USA'
            ? exporterData?.importerOfRecord
            : ''}
        </>
        )
      ) : (
        <></>
      );
    }

   

    rhsContent.push(
      <>
        <b>Invoice No: </b>
        {plantDetails?.invoiceNumber}
      </>
    );

    rhsContent.push(
      <>
        <b>Invoice Date: </b>
        {plantDetails?.invoiceDate
          ? moment(plantDetails?.invoiceDate).format('DD-MM-YYYY')
          : ''}
      </>
    );

    rhsContent.push(
      <>
        <b>Place Of Supply: </b>
        {plantDetails?.saleOrderItems?.[0]?.destinationDetails
          ? `${plantDetails.saleOrderItems[0].destinationDetails.toUpperCase()} , ${plantDetails.country ? plantDetails.country : ''}`
          : ''}
      </>
    );

    rhsContent.push(
      <>
        <b>Tax is payable On Reverse Charge : NO</b>
      </>
    );

    // rhsContent.push(
    //   <>
    //     <b>GST NO: </b>
    //     {exporterData?.GSTNumber}
    //   </>
    // );

    rhsContent.push(
      <>
        <b>
          Exporter's Ref
          <br />
          IE Code{' '}
        </b>{' '}
        {exporterData?.ieCode}
      </>
    );

    {
      conditionRes?.[0]?.duplicateBuyer === false ? (
        rhsContent.push(
          <>
            {plantDetails?.consigneeAddress != undefined ||
            plantDetails?.consignee != null ? (
              <b> Buyer </b>
            ) : (
              <b>Buyer & Consignee:</b>
            )}
           <br />
        {plantDetails?.endCustomerName}
        {plantDetails?.endCustomerName ? ':' : ''}
        <br />
        {plantDetails?.saleOrderItems[0]?.buyerAddress?.split(',')}
        <br />
        {plantDetails?.country ? plantDetails?.country:''}
      </>
        )
      ) : (
        <></>
      );
    }

    // rhsContent.push(
    //   <>
    //     {plantDetails?.consigneeAddress != undefined ||
    //     plantDetails?.consignee != null ? (
    //       <b> Buyer </b>
    //     ) : (
    //       <b>Buyer & Consignee:</b>
    //     )}
    //     <br />
    //     {plantDetails?.endCustomerName}
    //     {plantDetails?.endCustomerName ? ':' : ''}
    //     <br />
    //     {plantDetails?.saleOrderItems[0]?.buyerAddress?.split(',')}
    //     <br />
    //     {plantDetails?.country ? plantDetails?.country:''}
    //     <br/>
    //     {/* {plantDetails?.saleOrderItems[0]?.buy} */}
    //   </>
    // );

    {
      conditionRes?.[0]?.notifyPartyParam === true ? (
        rhsContent.push(
          <>
            <b>Notify Party:</b>
            {plantDetails.notifyPartyOne != null ? (
              <>
                {/* <u>Notify party 1</u> */}
                <br />
                <b>{plantDetails?.notifyPartyOne?.split('\n')[0]}</b>
                <br />
                {plantDetails?.notifyPartyOne?.split('\n')[1]}
                <br />
                {plantDetails?.notifyPartyOne?.split('\n')[2]}
                <br />
                {plantDetails?.notifyPartyOne?.split('\n')[3]}
                <br />
              </>
            ) : (
              ''
            )}
            {plantDetails.notifyPartyTwo != null ? (
              <>
                {/* <u>Notify party 2</u> */}
                <br />
                <b>{plantDetails?.notifyPartyTwo?.split('\n')[0]}</b>
                <br />
                {plantDetails?.notifyPartyTwo?.split('\n')[1]}
                <br />
                {plantDetails?.notifyPartyTwo?.split('\n')[2]}
                <br />
                {plantDetails?.notifyPartyTwo?.split('\n')[3]}
                <br />
                <br />
              </>
            ) : (
              ''
            )}
            {plantDetails.notifyPartyThree != null ? (
              <>
                {/* <u>Notify party 3</u> */}
                <br />
                  <b>{plantDetails?.notifyPartyThree?.split('\n')[0]}</b>
                  <br />
                  {plantDetails?.notifyPartyThree?.split('\n')[1]}
                  <br />
                  {plantDetails?.notifyPartyThree?.split('\n')[2]}
                  <br />
                  {plantDetails?.notifyPartyThree?.split('\n')[3]}
                <br />
                <br />
              </>
            ) : (
              ''
            )}
            {plantDetails.notifyPartyFour != null ? (
              <>
                {/* <u>Notify party 4</u> */}
                <br />
                <b>{plantDetails?.notifyPartyFour?.split('\n')[0]}</b>
                <br />
                {plantDetails?.notifyPartyFour?.split('\n')[1]}
                <br />
                {plantDetails?.notifyPartyFour?.split('\n')[2]}
                <br />
                {plantDetails?.notifyPartyFour?.split('\n')[3]}
                <br />
                <br />
              </>
            ) : (
              ''
            )}
          </>
        )
      ) : (
        <></>
      );
    }

    {
      plantDetails?.htsInfo?.[0]?.htsCode != null ||
      plantDetails?.htsInfo?.[0]?.htsCode != undefined ? (
        rhsContent.push(
          <>
            <b>HTS Code : </b>
            {plantDetails?.htsInfo.map((e) => e.htsCode).join(',')}
          </>
        )
      ) : (
        <></>
      );
    }

    rhsContent.push(
      <>
        <b>{conditionRes?.[0]?.terms} : </b>{' '}
        {plantDetails?.deliveryTerms}
      </>
    );
    {
      plantDetails?.saleOrderItems[0]?.buyerAddress.replace(/,/g, '') !=
      plantDetails?.saleOrderItems[0]?.deliveryaddress.replace(/,/g, '') ? (
        rhsContent.push(
          <>
            <b>
              <u>Shipp to:</u>
            </b>
            {plantDetails?.saleOrderItems[0]?.deliveryaddress}
          </>
        )
      ) : (
        <></>
      );
    }
  }
  console.log(ConstrunctLhsContent(plantDetails));

  let lhsCount = lhsContent.length;//3
  let rhsCount = rhsContent.length;//9
  const lhsRowSpanMap = new Map<number, number>();
  const lhsRowSpanCopyMap = new Map<number, number>();
  const blockSpanSize =  Math.round(rhsCount / lhsCount);//9/2 = 4.5=> 5
  const blockSpanSizeRem = Math.round(rhsCount % lhsCount);//1
  let rowNumber = 1;
  let index=0; //1
  let fulfilledCount = 0; // 4+3
  while (lhsCount > 0) {
    if(index === 0) {
    lhsRowSpanMap.set(rowNumber, blockSpanSize);//1,5 
    lhsRowSpanCopyMap.set(rowNumber, blockSpanSize);//1 ,5 
    fulfilledCount = blockSpanSize;//5
  } else {
    const remaing = rhsCount - fulfilledCount;//9-5=4
    const breakDownVal = Math.round( remaing / lhsCount);//4/3=1
    lhsRowSpanMap.set(rowNumber, breakDownVal);//1,5 | 2,1
    lhsRowSpanCopyMap.set(rowNumber, breakDownVal);//1 ,5 | 2,1
    fulfilledCount =blockSpanSize+ breakDownVal;
    
  }
    index++;//1
    rowNumber++;//2
    lhsCount--;//1
  }

  // lhsRowSpanMap.set(1, blockSpanSize + blockSpanSizeRem);
  // lhsRowSpanCopyMap.set(1, blockSpanSize + blockSpanSizeRem);
  let lhsPrintingRowNumber = 1;
  let lhsPrintingIndexNumber = 0;

console.log(lhsRowSpanCopyMap.get(
  lhsPrintingRowNumber
));
let totalInvoiceAmount=0

  return (
    <div>
      <span style={{marginLeft:935}}>
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="download-table-xls-button"
          table="table-to-xls"
          filename="ExportInvoice"
          sheet="ExportInvoice"
          buttonText="Get Excel" />
      </span>
      <br />
      {plantDetails ? (
        <html>
          <head></head>
          <br />
          <body id="print" className={'stylesInfo'}>
            <br></br>
            <table
              className={'ta-b'}
              style={{ width: '100%' }}
              id="table-to-xls"
            >
              <tr>
                <td
                  className={'ta-b'}
                  colSpan={9}
                  style={{
                    textAlign: 'center',
                    }}
                >
                  <h1>EXPORT INVOICE</h1>
                </td>
              </tr>
              {plantDetails?.isTaxApplicable === 'YES' ? (
                <tr>
                  <td
                    className={'ta-b'}
                    style={{ textAlign: 'center' }}
                    colSpan={9}
                  >
                    <h2>
                      "SUPPLY MEANT FOR EXPORT UNDER LETTER OF UNDERTAKING WITH
                      PAYMENT OF IGST"
                    </h2>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td
                    className={'ta-b'}
                    style={{ textAlign: 'center' }}
                    colSpan={9}
                  >
                    <h2>
                      "SUPPLY MEANT FOR EXPORT UNDER LETTER OF UNDERTAKING WITHOUT
                      PAYMENT OF IGST"
                    </h2>
                  </td>
                </tr>
              )}
           {rhsContent.map((r, i) => {
                  let currRowSpanConsumption = lhsRowSpanMap.get(lhsPrintingRowNumber);
                  let currRowSpanReducedCons = lhsRowSpanCopyMap.get(lhsPrintingRowNumber);
                  lhsRowSpanCopyMap.set(lhsPrintingRowNumber, currRowSpanReducedCons - 1);

                  if (Number(currRowSpanReducedCons) - 1 === 0) {
                    lhsPrintingIndexNumber++;
                    lhsPrintingRowNumber++;
                  }

                  return (
                    <>

       
                    <tr key={i}>
                      {currRowSpanConsumption === currRowSpanReducedCons && (
                        <td
                          colSpan={5}
                          className={'ta-b'}
                          rowSpan={currRowSpanConsumption}
                          style={{
                            display:
                              currRowSpanConsumption === currRowSpanReducedCons ? '' : 'none',
                              verticalAlign:'top',
                          }}
                        >
                          {lhsContent[lhsPrintingIndexNumber]}
                        </td>
                      )}
                      <td className={'ta-b'} colSpan={5}>
                        {r}
                      </td>
                    </tr>
                    </>

                  );
   })}
              {/* <tr> */}
              {/* <td style={{textAlign:'left', border:'1px solid black', verticalAlign:'top', paddingTop:'5px',paddingLeft:'5px'}} colSpan={4} rowSpan={4}>
                  <b>Exporter:</b> <br />
                  <h4>
                  {(exporterData?.name) ? exporterData?.name : ''}
                  <br />
                  {(exporterData?.addressOne) ? exporterData?.addressOne + ',' : ''}
                  <br />
                  {(exporterData?.addressTwo) ? (exporterData?.addressTwo) + ' - ' + exporterData?.postalCode : ''}
                  <br />
                  {exporterData?.state + ', ' + exporterData?.country}
                  <br />
                  GSTIN: {exporterData?.GSTNumber}
                  <br />
                  USFDA REGN NO: {exporterData?.usfdaRegNo}
                  </h4>
                </td> */}
              {/* <td className={'ta-b'} colSpan={5}>
                  <b>Invoice No: </b>
                  {plantDetails?.invoiceNumber}<br /> */}
              {/* <b>Invoice Date: </b>
                  {moment(plantDetails?.invoiceDate).format('DD-MMM-YYYY')} */}
              {/* </td> */}

              {/* */}
              {/* </tr>
              <tr>
                <td className={'ta-b'} colSpan={5}>

                  <b>Invoice Date: </b>
                  {plantDetails?.invoiceDate?moment(plantDetails?.invoiceDate).format('DD-MMM-YYYY'):''}
                </td>
              </tr> */}

              {/* <tr>
                <td className={'ta-b'} colSpan={5}>
                  <b>Place Of Supply: </b> {(plantDetails?.saleOrderItems[0]?.destinationDetails ? (plantDetails?.shipmentTerms ? plantDetails?.shipmentTerms : '')+ "," + (plantDetails?.saleOrderItems[0]?.destinationDetails)?.toUpperCase() : '') + "," + (plantDetails?.country ? plantDetails?.country : '')}
                    </td></tr> */}
              {/* {moment(plantDetails?.invoiceDate).format('DD-MMM-YYYY')} */}
              {/* <tr>
                  <td className={'ta-b'} colSpan={5}>
                  <b>Tax is payable On Reverse Charge : NO</b>
                </td>
              </tr> */}

              {/* {plantDetails?.consigneeAddress != undefined|| plantDetails?.consignee!=null?
                (<tr> 
                  <td className={'ta-b'} colSpan={4} rowSpan={conditionRes?.[0]?.importerDetails === true ?conditionRes?.[0]?.shipping=== true?2:2:5}>
                      <b><u>Consignee:</u></b><br/>
                      {plantDetails?.consignee}{plantDetails?.consignee ? ':' : ''}<br />
                    {plantDetails?.country ? plantDetails?.country:''}
                    {plantDetails?.consigneeAddress?.split(",")[0] + ","}<br />
                    {plantDetails?.consigneeAddress?.split(",")[1] + ","}
                    {plantDetails?.consigneeAddress?.split(",")[2] + ","}
                    {plantDetails?.consigneeAddress?.split(",")[3]}<br />
                    </td>
                    <td className={'ta-b'} colSpan={5}>

<b>GST NO: </b>
{exporterData?.GSTNumber}         
</td>
                    </tr>
                   ):(
                   <tr>
                      <td className={'ta-b'} colSpan={5}>

<b>GST NO: </b>
{exporterData?.GSTNumber}         
</td>
                   </tr>)}
              
              <tr>
              <td className={'ta-b'} colSpan={5}>
                  <b>Exporter's Ref<br />
                    IE Code </b> {exporterData?.ieCode}
                </td>
              </tr>
            
              <tr>
             {conditionRes?.[0]?.importerDetails === true ?(
               <td className={'ta-b'} colSpan={conditionRes?.[0]?.shipping === true? 2 :4 } rowSpan={plantDetails?.consigneeAddress != undefined|| plantDetails?.consignee!=null?3:5}>
                  <b>
                    Importer of record:
                  </b><br />
                  <h4 style={{ display: 'inline',lineHeight:'1px' }}>{(exporterData?.name) ? exporterData?.name : ''}</h4><br />
                  {(exporterData?.addressOne) ? exporterData?.addressOne + ',' : ''}
                  <br />
                  {(exporterData?.addressTwo) ? (exporterData?.addressTwo) + ' - ' + exporterData?.postalCode : ''}
                  <br /> 
                  {exporterData?.state + ', ' + exporterData?.country}
                <br/>
                <b>Import On Record: </b>{plantDetails?.country==='USA'?exporterData?.importerOfRecord:''}
                </td>
              ):(<></>)} 

              {conditionRes?.[0]?.shipping=== true?(
                <td className={'ta-b'} colSpan={2} rowSpan={2}>
                  <b><u>Shipping terms:</u></b>{plantDetails?.saleOrderItems[0]?.deliveryaddress}
                </td>
              ):(<></>)}
               {plantDetails?.saleOrderItems[0]?.buyerAddress.replace(/,/g, '')!= plantDetails?.saleOrderItems[0]?.deliveryaddress.replace(/,/g, '') ?(
                <td className={'ta-b'} colSpan={conditionRes?.[0]?.shipping === true? 2 :4} rowSpan={plantDetails?.consigneeAddress != undefined|| plantDetails?.consignee!=null?3:5}>
                  <b><u>Shipp to:</u></b>{plantDetails?.saleOrderItems[0]?.deliveryaddress}
                </td>
              ):(<></>)}
                <tr>
                {conditionRes?.[0]?.duplicateBuyer === true ?(<>
                  <td className={'ta-b'} colSpan={5}>
              {plantDetails?.consigneeAddress != undefined|| plantDetails?.consignee!=null?(<b> Buyer </b>):(<b>Buyer & Consignee:</b>)}<br />
                  {conditionRes?.[0]?.duplicateBuyerAddress}
                </td>
                </>):(<>
                
              <td className={'ta-b'} colSpan={5}>
              {plantDetails?.consigneeAddress != undefined|| plantDetails?.consignee!=null?(<b> Buyer </b>):(<b>Buyer & Consignee:</b>)}<br />
                  {plantDetails?.endCustomerName}{plantDetails?.endCustomerName ? ':' : ''}<br />
                  {plantDetails?.country ? plantDetails?.country:''}
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[0] + ","}<br />
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[1] + ","}
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[2] + ","}
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[3]}<br /> */}
              {/* {
                    plantDetails?.endCustomerName === 'AZ Gems' ?
                    <>
                    <b>FDA REGISTRATION NO.</b>{unitsData?.consigneefdaRegNumber}
                    </> : ''
                  } */}
              {/* </td></>)}
              </tr>
                 {conditionRes?.[0]?.notifyPartyParam === true ?(
                <td className={'ta-b'} colSpan={5}>
                <b>Notify Party:</b>
                  {
                  (plantDetails.notifyPartyOne) ?
                      <><u>
                      Notify party 1</u><br />
                        <b>{plantDetails?.notifyPartyOne?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyOne?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyOne?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyOne?.split("\n")[3]}<br /></>:''
                }
                {
                  (plantDetails.notifyPartyTwo) ?
                  <><u>
                      Notify party 2</u><br />
                        <b>{plantDetails?.notifyPartyTwo?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyTwo?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyTwo?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyTwo?.split("\n")[3]}<br /><br /></>:''

                      }
                {
                  (plantDetails.notifyPartyThree) ?
                      <><u>
                      Notify party 3</u><br /><pre>
                        <b>{plantDetails?.notifyPartyThree?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyThree?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyThree?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyThree?.split("\n")[3]}</pre><br /><br /></>:''
                      }
                {
                  (plantDetails.notifyPartyFour) ?
                  <>
                  <u>
                      Notify party 4</u><br />
                        <b>{plantDetails?.notifyPartyFour?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyFour?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyFour?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyFour?.split("\n")[3]}<br /><br /></>:''
                }
                </td>
               ):<></>}
            </tr>
            {plantDetails?.htsInfo?.[0]?.htsCode!= null || plantDetails?.htsInfo?.[0]?.htsCode!= undefined?
            <tr>
            <td className={'ta-b'} colSpan={5}><b>HTS Code : </b>{plantDetails?.htsInfo.map((e)=>e.htsCode).join(',')}</td>
            </tr>
            :<></>}
             <tr>
                <td className={'ta-b'} colSpan={5}>
                    <b>{conditionRes?.[0]?.terms}</b>
                    {plantDetails?.deliveryTerms}
                </td>
                </tr> */}
              {/* <tr>
                <td className={'ta-b'} colSpan={3}>
                    <b>Container No:</b>
                    {plantDetails?.saleOrderItems[0]?.containerNo}
                </td>
                <td className={'ta-b'} colSpan={2}>
                    <b>Seal No:</b>
                    {plantDetails?.saleOrderItems[0]?.linearSelaNo}
                </td>
                </tr> */}
              <tr>
                <td
                  className={'ta-b'}
                  colSpan={9}
                  style={{
                    textAlign: 'center',
                    }}
                >
                  <b>{conditionRes?.[0]?.poLabel} :</b>{''}
                  {plantDetails.custPoNo}{''}
                  <b>Date : </b>
                  {moment(plantDetails.poDate).format('DD-MM-YYYY')}
                  </td>
              </tr>
              {plantDetails?.lcName ? (
                <>
                  <tr>
                    <td
                      className={'ta-b'}
                      colSpan={9}
                      style={{ textAlign: 'center' }}
                    >
                      <b>{plantDetails?.lcName} : </b>
                      {plantDetails?.lcNo} <b> date of issue : </b>
                      {moment(plantDetails?.lcDate).format('DD-MM-YYYY')},
                      <br />
                      {plantDetails?.lcBankAddress}, <b>For usd </b>
                      {plantDetails?.lcAmount}
                    </td>
                  </tr>
                </>
              ) : (
                <></>
              )}
              <tr>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Pre Carriage By</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Vessel No</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Port Of Loading</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Port Of Discharge</b>
                </td>
                <td className={'ta-b'} colSpan={2} style={{textAlign:"center"}}>
                  <b>
                    {conditionRes?.[0]?.destinationDetails
                      ? conditionRes?.[0]?.destinationDetails
                      : ''}
                  </b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}} colSpan={2}>
                  <b>Terms & Payments</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Origin Of Goods</b>
                </td>
              </tr>
              <tr>
                <td className={'ta-b'} style={{textAlign:"center"}}>{plantDetails?.vesselName}</td>
                <td className={'ta-b'} style={{textAlign:"center"}}> {plantDetails?.vesselNumber}</td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>
                    {plantDetails?.portofloading
                      ? plantDetails?.portofloading?.toUpperCase() 
                      : ''}
                  </b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  {(plantDetails?.saleOrderItems[0]?.destinationDetails
                    ? plantDetails?.saleOrderItems[0]?.destinationDetails?.toUpperCase()
                    : '') +
                    ',' +
                    (plantDetails?.country ? plantDetails?.country : '')}
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}} colSpan={2}>
                  {(plantDetails?.saleOrderItems[0]?.destinationDetails
                    ? plantDetails?.saleOrderItems[0]?.destinationDetails?.toUpperCase()
                    : '') +
                    ',' +
                    (plantDetails?.country ? plantDetails?.country : '')}
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}} colSpan={2}>
                  {plantDetails?.saleOrderItems[0]?.paymentTerms}
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}} colSpan={1}>
                  INDIA
                </td>
              </tr>
              <tr>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>Marks & Nos.</b>
                  <br />
                  {plantDetails?.marksAndNo}
                </td>
                <td
                  className={'ta-b'} style={{textAlign:"center"}}
                  colSpan={plantDetails?.isItem === true ? 2 : 3}
                >
                  <b>Description Of Goods</b>
                </td>
                {plantDetails?.isItem === true ? (
                  <>
                    <td className={'ta-b'} style={{textAlign:"center"}} colSpan={1}>
                      <b>Item Code</b>
                    </td>
                  </>
                ) : (
                  <></>
                )}{' '}
                <td className={'ta-b'} style={{textAlign:"center"}}> 
                  <b>Size</b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>No.Of Cartons</b>
                </td>
                <td
                  className={'ta-b'}
                  colSpan={1}
                  style={{ textAlign: 'center', borderBottom: '0px' }}
                >
                  <b>
                    {' '}
                    Quantity{' '}
                    {conditionRes?.[0]?.quantityUom === true
                      ? ' ( IN LBS ) '
                      : ' ( IN KGS ) '}
                  </b>
                </td>
                {/* <td className={'ta-b'}><b>Quantity (In LBS.)</b></td> */}
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>
                    Price usd /{' '}
                    {conditionRes?.[0]?.quantityUom === true ? 'LB' : 'KG'}
                  </b>
                </td>
                <td className={'ta-b'} style={{textAlign:"center"}}>
                  <b>
                    Amount IN USD{' '}
                    {conditionRes?.[0]?.amountParam === true
                      ? plantDetails.shipmentTerms
                      : ''}
                  </b>
                </td>
              </tr>
              {/* <tr>
                <td className={'ta-b'} colSpan={3} rowSpan={2}>
                  <b>Exporter:</b> <br />
                  <h4 style={{ display: 'inline' }}>{(exporterData?.name) ? exporterData?.name : ''}</h4><br />
                  {(exporterData?.addressOne) ? exporterData?.addressOne + ',' : ''}
                  <br />
                  {(exporterData?.addressTwo) ? (exporterData?.addressTwo) + ' - ' + exporterData?.postalCode : ''}
                  <br />
                  {exporterData?.state + ', ' + exporterData?.country}
                  <br />

                </td>
                <td className={'ta-b'} colSpan={3}>
                  <b>Invoice No. </b>
                  {plantDetails?.invoiceNumber}<br />
                  <b>Date: </b>
                  {moment(plantDetails?.invoiceDate).format('DD-MMM-YYYY')}
                </td>

                <td className={'ta-b'} colSpan={2}>
                  <b>Exporter's Ref<br />
                    IE Code </b> {exporterData?.ieCode}
                </td>
              </tr>
              <tr>
                <td colSpan={5} className={'ta-b'}>
                  <b>Buyer's Order No. </b>
                  PO NO. {plantDetails.custPoNo}
                  
                </td>
              </tr>
              <tr>
                <td className={'ta-b'} colSpan={3} rowSpan={plantDetails?.notifyPartyThree ? 2 : 1} style={{ textAlign: 'start' }}>
                  PROCESSED & PACKED AT <br />
                  <h4 style={{ display: 'inline' }}><b>{(exporterData?.name) ? exporterData?.name : ''}</b></h4><br />
                  {plantDetails?.invoicedPlant?.villageName + ", " + plantDetails?.invoicedPlant?.mandalName}<br />
                  {plantDetails?.invoicedPlant?.postalCode + ", " + plantDetails?.invoicedPlant?.distirctName + ", " + plantDetails?.invoicedPlant?.stateName + ", " + plantDetails?.invoicedPlant?.countryName}<br />
                  <b>FDA REGISTRATION NUMBER :</b>{plantDetails?.invoicedPlant?.fdaRegNumber}
                  <br />
                  {plantDetails?.invoicedPlant?.feiNumber ?
                    <><b>FEI NUMBER:</b>{plantDetails?.invoicedPlant?.feiNumber}</> : <></>}
                </td>
                {
                  (plantDetails.notifyPartyOne) ?
                    <td colSpan={plantDetails?.notifyPartyOne ? 3 : 5} className={'ta-b'} style={{ textAlign: 'start', fontFamily: 'Arial Narrow' }}>
                      <u>
                        Notify party 1</u>
                      <br />
                      <pre>
                        <b>{plantDetails?.notifyPartyOne?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyOne?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyOne?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyOne?.split("\n")[3]}</pre><br />
                      

                    </td> : <></>
                }
                {
                  (plantDetails.notifyPartyTwo) ?
                    <td colSpan={2} className={'ta-b'} style={{ textAlign: 'start', width: '50%', fontFamily: 'Arial Narrow' }}>
                      <u>
                        Notify party 2</u>
                      <br />
                      <pre>
                        <b>{plantDetails?.notifyPartyTwo?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyTwo?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyTwo?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyTwo?.split("\n")[3]}</pre><br /><br />

                    </td> : <></>
                }
              </tr>
              <tr >
                {
                  (plantDetails.notifyPartyThree) ?
                    <td colSpan={plantDetails.notifyPartyFour ? 3 : 5} className={'ta-b'} style={{ textAlign: 'start', fontFamily: 'Arial Narrow' }}>
                      <u>
                        Notify party 3</u>
                      <br />
                      <pre>
                        <b>{plantDetails?.notifyPartyThree?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyThree?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyThree?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyThree?.split("\n")[3]}</pre><br /><br />
                    </td>
                    : <></>
                }
                {
                  (plantDetails.notifyPartyFour) ?
                    <td colSpan={2} className={'ta-b'} style={{ textAlign: 'start', fontFamily: 'Arial Narrow' }}>
                      <u>
                        Notify party 4</u>
                      <br />
                      <pre>
                        <b>{plantDetails?.notifyPartyFour?.split("\n")[0]}</b><br />
                        {plantDetails?.notifyPartyFour?.split("\n")[1]}<br />
                        {plantDetails?.notifyPartyFour?.split("\n")[2]}<br />
                        {plantDetails?.notifyPartyFour?.split("\n")[3]}</pre><br /><br />
                    </td>
                    : <></>
                }
              </tr>
              <tr >
                <td colSpan={3} rowSpan={2} className={'ta-b'}>
                  Consignee:<br />
                 
                  {
                     plantDetails?.country === "INDIA" && (
                      <>
                         <b>AZ GEMS INDIA INC:</b>
                      </>
                     )
                  }
                  {
                    plantDetails?.country === "USA" && (
                      <><b>AZ GEMS INC:</b></>
                    )
                  }<br></br>
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[0] + ","}<br />
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[1] + ","}
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[2] + ","}
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[3]}<br />
                  {
                    plantDetails?.endCustomerName === 'AZ Gems' ?
                    <>
                    <b>FDA REGISTRATION NO.</b>{unitsData?.consigneefdaRegNumber}
                    </> : ''
                  }
                </td>
                <td colSpan={5} className={'ta-b'} >
                  <b>
                    Importer on record:
                  </b><br />
                  
                  {
                     plantDetails?.country === "INDIA" && (
                      <>
                         <b>AZ GEMS INDIA INC:</b>
                      </>
                     )
                  }
                  {
                    plantDetails?.country === "USA" && (
                      <><b>AZ GEMS INC:</b></>
                    )
                  }<br />
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[0] + ","}<br />
                  {plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[1] + "," + plantDetails?.saleOrderItems[0]?.customeraddress?.split(",")[2] + "," + plantDetails?.saleOrderItems[0]?.customeraddress.split(",")[3]}
                  <br />{
                    plantDetails?.endCustomerName === 'AZ Gems' ?
                    <>
                    <b>FDA REGISTRATION NO.</b>{unitsData?.consigneefdaRegNumber}
                    </> : ''
                  }
                </td>
              </tr>

              <tr>
                <td colSpan={3} className={'ta-b'}>
                  Country of Origin of Goods:<br />
                  <b > INDIA</b>
                </td>
                <td colSpan={5} className={'ta-b'}>
                  <b> Country of Final Destination:</b><br />
                  {plantDetails?.country}{' '}
                </td>
              </tr>
              <tr>
                <td className={'ta-b'} colSpan={2}>
                  Pre Carriage By:
                  <h4>Road</h4>
                </td>
                <td className={'ta-b'} colSpan={1}>
                  Place of Receipt of Pre-carrier:
                  <b>{plantDetails?.placeOfReceipt != undefined ? plantDetails.placeOfReceipt : null}</b>
                </td>
                <td colSpan={5} className={'ta-b'}>
                  Terms of Delivery and Payment:<br />
                  <span style={{ textAlign: 'center' }}><b>{plantDetails?.saleOrderItems[0]?.paymentTerms}</b></span>
                </td>
              </tr>

              <tr>

                <td className={'ta-b'} colSpan={2}>
                  Vessel / Flight No.


                </td>
                <td className={'ta-b'} colSpan={1}>
                  Port of Loading: <br />

                  <b>{plantDetails?.portofloading ? (plantDetails?.portofloading)?.toUpperCase() + ', INDIA' : ''}</b>


                </td>

                <td colSpan={5} rowSpan={2} className={'ta-b'}>
                  Container No.&nbsp;
                  <b></b>
                  <br />
                  Liner Seal No.&nbsp;
                  
                  <br />
                  Bill of Lading No.&nbsp;
                 
                </td>
              </tr>
              <tr>
                <td className={'ta-b'} colSpan={2}>
                  Port of Discharge:<br />
                  <b>{(plantDetails?.saleOrderItems[0]?.destinationDetails ? (plantDetails?.saleOrderItems[0]?.destinationDetails)?.toUpperCase() : '') + "," + (plantDetails?.country ? plantDetails?.country : '')}</b>
                </td>
                <td className={'ta-b'} colSpan={1}>
                  Final Destination:<br />
                  <b>{(plantDetails?.saleOrderItems[0]?.destinationDetails ? (plantDetails?.saleOrderItems[0]?.destinationDetails)?.toUpperCase() : '') + "," + (plantDetails?.country ? plantDetails?.country : '')}</b>
                </td>
              </tr>
              <tr>
                <td colSpan={1} style={{ textAlign: 'center', fontSize: 10 }}>
                  Marks & Nos / No & Kind of Pkgs
                </td>
                <td colSpan={1} style={{ textAlign: 'center' }}>
                </td>
                <td style={{ textAlign: 'center', paddingLeft: '55px' }} colSpan={2}>
                  Description of Goods
                </td>

                <td style={{ textAlign: 'center' }}>
                </td>
                <th className={'ta-b'} colSpan={1} style={{ textAlign: 'center', borderBottom: '0px' }} rowSpan={2}>
                  Quantity
                  <br />
                  {
                    plantDetails?.country === 'INDIA' ? <>
                      IN KGs
                    </> : <>IN LBs</>
                  } <br /> NET WEIGHT
                </th>
                <th className={'ta-b'} colSpan={1} style={{ textAlign: 'center', borderBottom: '0px' }} rowSpan={2}>
                  Rate
                  <br />
                  {
                    plantDetails?.country === 'INDIA' ? <>
                      PER KGs
                    </> : <>PER LBs</>
                  } <br />
                  <br />({plantDetails?.saleOrderItems[0]?.currencyDetails})
                  <br />{plantDetails?.shipmentTerms}
                  <br />{plantDetails?.saleOrderItems[0].destinationDetails}
                </th>
                <th className={'ta-b'} colSpan={1} style={{ textAlign: 'center', borderBottom: '0px' }} rowSpan={2}>
                  Amount
                  <br /> ({plantDetails?.saleOrderItems[0]?.currencyDetails})
                  <br /> {plantDetails?.shipmentTerms}
                  <br /> {plantDetails?.saleOrderItems[0].destinationDetails}
                </th>
              </tr>
              <tr>
                <th colSpan={1} style={{ textAlign: 'center' }}>
                </th>
                <th colSpan={1} style={{ textAlign: 'center' }}>
                  HSN Code
                </th>
                <th style={{ textAlign: 'left' }} colSpan={2}>
                  Size
                </th>
                <th style={{ textAlign: 'left', width: '30%' }}>
                  No. Of Cartons
                </th>
              </tr> */}

              {
                // let totalRowSpan = 0;

                plantDetails.gradeInfo.map((g, prodIndex) => {
                  let prodRowSpan = containerProductLevelRowSpan.get(prodIndex);
                  return g.info.map((r, index) => {
                    // netWeightInKgs += Number(r.netWeight) * 0.454;
                    let freightCharges =
                      plantDetails?.freightCharges === undefined
                        ? 0
                        : plantDetails?.freightCharges;
                    let exchangeRate =
                      plantDetails?.exchangeRate === undefined
                        ? 0
                        : plantDetails?.exchangeRate;
                    totalCases += r.noOfCases;
                    const uom = UnitsOfWeightInput.find(
                      (uom) => uom.value == r.uomId
                    );
                    const uomPrice = UnitsOfWeightInput.find(
                      (uom) => uom.value == r.priceUom
                    );
                    let finalNetWeight;
                    let unitPrice;
                    let invUnitPrice;

                    if (plantDetails.isInvoiced == GlobalStatus.YES) {
                      if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                        {
                          conditionRes?.[0]?.quantityUom === true
                            ? (finalNetWeight = Number(r.quatity))
                            : (finalNetWeight = (
                                Number(r.quatity) * 0.454
                              ).toFixed(3));
                        }
                        unitPrice = (Number(r.revisedPrice) * 0.454).toFixed(2);
                        grossWeightInKg = (
                          Number(
                            plantDetails?.grossWeight
                              ? plantDetails?.grossWeight
                              : 0
                          ) * 0.454
                        ).toFixed(3);
                        frozenWeightInKg = (
                          Number(
                            plantDetails?.frozenWeight
                              ? plantDetails?.frozenWeight
                              : 0
                          ) * 0.454
                        ).toFixed(3);
                        netWeightInKgs += Number(r.quatity)*0.454
                        netWeightInLbs += Number(r.quatity)

                      } else {
                        {
                          conditionRes?.[0]?.quantityUom === true
                            ? (finalNetWeight = (
                                Number(r.quatity) / 0.454
                              ).toFixed(3))
                            : (finalNetWeight = Number(r.quatity).toFixed(3));
                        }
                        unitPrice = Number(r.revisedPrice).toFixed(2);
                        grossWeightInKg = Number(
                          plantDetails?.grossWeight
                            ? plantDetails?.grossWeight
                            : 0
                        ).toFixed(3);
                        frozenWeightInKg = Number(
                          plantDetails?.frozenWeight
                            ? plantDetails?.frozenWeight
                            : 0
                        ).toFixed(3);
                        netWeightInKgs += Number(r.quatity)
                        netWeightInLbs += Number(r.quatity)/0.454
                      }
                    } else {
                      if (uom.name == UomEnum.LB || uom.name == UomEnum.OZ) {
                        {
                          conditionRes?.[0]?.quantityUom === true
                            ? (finalNetWeight = Number(r.quatity))
                            : (finalNetWeight = (
                                Number(r.quatity) * 0.454
                              ).toFixed(3));
                        }
                        unitPrice = (Number(r.revisedPrice) * 0.454).toFixed(2);
                        grossWeightInKg = (
                          Number(
                            plantDetails?.grossWeight
                              ? plantDetails?.grossWeight
                              : 0
                          ) * 0.454
                        ).toFixed(3);
                        frozenWeightInKg = (
                          Number(
                            plantDetails?.frozenWeight
                              ? plantDetails?.frozenWeight
                              : 0
                          ) * 0.454
                        ).toFixed(3);
                        netWeightInKgs += Number(r.quatity)*0.454
                        netWeightInLbs += Number(r.quatity)
                      } else {
                        {
                          conditionRes?.[0]?.quantityUom === true
                            ? (finalNetWeight = (
                                Number(r.quatity) / 0.454
                              ).toFixed(3))
                            : (finalNetWeight = Number(r.quatity).toFixed(3));
                        }
                        unitPrice = Number(r.revisedPrice).toFixed(2);
                        grossWeightInKg = Number(
                          plantDetails?.grossWeight
                            ? plantDetails?.grossWeight
                            : 0
                        ).toFixed(3);
                        frozenWeightInKg = Number(
                          plantDetails?.frozenWeight
                            ? plantDetails?.frozenWeight
                            : 0
                        ).toFixed(3);
                        netWeightInKgs += Number(r.quatity)
                        netWeightInLbs += Number(r.quatity)/0.454
                      }
                    }
                    {conditionRes[0]?.isRevisedPrice === true? (
                          conditionRes?.[0]?.quantityUom === true?
                          (


                            uomPrice.name == UomEnum.LB || uomPrice.name == UomEnum.OZ?(
                              invUnitPrice = Number(r.revisedPrice ? r.revisedPrice : 0).toFixed(2)):(
                            invUnitPrice = (Number(r.revisedPrice ? r.revisedPrice : 0)*Number(2.20462)).toFixed(2))):
                            (uomPrice.name == UomEnum.LB || uomPrice.name == UomEnum.OZ?(
                              invUnitPrice = (Number(r.revisedPrice ? r.revisedPrice : 0)*Number(2.20462)).toFixed(2)):
                            (invUnitPrice = Number(r.revisedPrice ? r.revisedPrice : 0).toFixed(2)))


                         
                        ): (
                          conditionRes?.[0]?.quantityUom === true?(
                            uomPrice.name == UomEnum.LB || uomPrice.name == UomEnum.OZ?(
                              invUnitPrice = Number(r.price ? r.price : 0).toFixed(2)):(
                            invUnitPrice = (Number(r.price ? r.price : 0)*Number(2.20462)).toFixed(2))):
                            (uomPrice.name == UomEnum.LB || uomPrice.name == UomEnum.OZ?(
                              invUnitPrice = (Number(r.price ? r.price : 0)*Number(2.20462)).toFixed(2)):
                            (invUnitPrice = Number(r.price ? r.price : 0).toFixed(2)))
                          )}
  
                      
                    totalLbWeight += Number(finalNetWeight);
                    totalAmount += Number(
                      Number(invUnitPrice) * Number(finalNetWeight)
                    );
                    
                    totalInvoiceAmount += Number(r.invoiceAmount);

                    
                    {
                      conditionRes?.[0]?.cvd === true
                        ? (subTotal = Number(
                          totalInvoiceAmount -
                              Number(
                                plantDetails.freightCharges
                                  ? plantDetails.freightCharges
                                  : 0
                              )
                          ))
                        : 0;
                    }
                    {
                      conditionRes?.[0]?.cvd === true
                        ? (cvdVal = (
                            Number(subTotal) * Number(cvdDetails / 100)
                          ).toFixed(2)  )                     
                        : 0;
                    }
                    {
                      conditionRes?.[0]?.cvd === true
                        ? (antiDumping = (subTotal * (1.35 / 100)).toFixed(2))
                        : conditionRes?.[0]?.freightRate === true
                        ? (antiDumping = Number(
                            Number(
                              totalInvoiceAmount -
                                Number(
                                  plantDetails.freightCharges
                                    ? plantDetails.freightCharges
                                    : 0
                                )
                            ) *
                              (1.35 / 100)
                          ).toFixed(2))
                        : (antiDumping = (
                            Number(totalInvoiceAmount) *
                            (1.35 / 100)
                          ).toFixed(2));
                    }
                    {conditionRes?.[0]?.cvd === true&&plantDetails?.deliveryTerms.includes('DDP') ?(
                      
                      mpfVal= Number(((subTotal)-(Number(cvdVal?cvdVal:0)))* Number(mpfDetails / 100)).toFixed(2),
                      tariffVal = Number(((subTotal)-(Number(mpfVal?mpfVal:0)) )* Number(tariffDetails / 100)).toFixed(2)
                    ):(<></>)}
                    
  //                   const isDDP = plantDetails?.deliveryTerms.includes('DDP');
  // const hasAntiDumping = conditionRes?.[0]?.antiDumping === true && conditionRes?.[0]?.freightRate === true;
  // const hasCVD = conditionRes?.[0]?.cvd === true && conditionRes?.[0]?.freightRate === true;

  // Calculate combined percentages if DDP is present
  const combinedPercentage = plantDetails?.deliveryTerms.includes('DDP')
    ? 1.35 + Number(cvdDetails || 0) + Number(mpfDetails || 0) + Number(tariffDetails || 0)
    : 0;

  const subTotalValue = Number(subTotal || 0);
  const taxOnSubtotal = (subTotalValue * combinedPercentage);
  const taxBase = 100 + combinedPercentage;
  const totalvalue=taxOnSubtotal/taxBase
                    {
                      conditionRes?.[0]?.cvd === true && plantDetails?.deliveryTerms.includes('DDP')
                        ? (fob =
                            Number(subTotal ? subTotal : 0) - Number(totalvalue)
                            
                          ): conditionRes?.[0]?.cvd === true?(fob =
                            Number(subTotal ? subTotal : 0)-
                            Number(antiDumping ? antiDumping : 0) -
                            Number(cvdVal ? cvdVal : 0)-
                            (plantDetails?.deliveryTerms.includes('DDP') ?Number(mpfVal ? mpfVal : 0):0)-
                            (plantDetails?.deliveryTerms.includes('DDP') ?Number(tariffVal ? tariffVal : 0):0)

                            
                          )
                          
                        : conditionRes?.[0]?.freightRate === true
                        ? (fob = Number(
                            totalInvoiceAmount -
                              Number(
                                plantDetails.freightCharges
                                  ? plantDetails.freightCharges
                                  : 0
                              ) 
                          ).toFixed(2))
                        : (fob = Number(
                            totalInvoiceAmount 
                          ).toFixed(2));
                    }

                    // return (
                    //   <tr key={index}>
                    //     <td
                    //       className="ta-b"
                    //       rowSpan={totalContainersRowSpan}
                    //       style={{
                    //         display:
                    //           totalContainersRowSpan-- == copiedContainerRowSpan
                    //             ? ''
                    //             : 'none',
                    //       }}
                    //     >
                    //       <b>Container No:</b>
                    //       {plantDetails?.saleOrderItems[0]?.containerNo}
                    //       <br />
                    //       <hr  style={{
                    //                  border: 'none', // Remove the default border
                    //                  borderBottom: '2px solid #000', // Dark color for the line
                    //                  margin: 0,
                    //                  marginBottom: '-1px', // Adjust this to fine-tune the alignment
                    //                   }}/>
                    //       <b>Seal No:</b>
                    //       {plantDetails?.saleOrderItems[0]?.linearSelaNo}
                    //     </td>
                    //     <td
                    //       className="ta-b"
                    //       rowSpan={containerProductLevelRowSpan.get(prodIndex)}
                    //       colSpan={plantDetails?.isItem === true ? 2 : 3}
                    //       style={{
                    //         display:
                    //           prodRowSpan-- ==
                    //           containerProductLevelRowSpan.get(prodIndex)
                    //             ? ''
                    //             : 'none',textAlign:"center"
                    //       }}
                    //     >
                    //       {g.productDescription}
                    //     </td>
                    //     {plantDetails?.isItem === true ? (
                    //       <td className="ta-b">{r.itemCode}</td>
                    //     ) : (
                    //       <></>
                    //     )}
                    //     <td className="ta-b" style={{textAlign:"center"}}>
                    //       {r.minGrade}/{r.maxGrade}
                    //       {r.grade && (
                    //         <>
                    //           <br />({r.grade})
                    //         </>
                    //       )}
                    //     </td>

                    //     <td className="ta-b" style={{textAlign:"center"}}>{r.noOfCases}</td>
                    //     <td className="ta-b" style={{textAlign:"center"}}>
                    //       {finalNetWeight
                    //         ? Number(finalNetWeight).toLocaleString(undefined, {
                    //             minimumFractionDigits: 2,
                    //             maximumFractionDigits: 2,
                    //           })
                    //         : 0}
                    //     </td>
                    //     <td className="ta-b" style={{textAlign:"center"}}> {parseFloat(invUnitPrice).toFixed(2)}</td>
                    //     <td className="ta-b" style={{textAlign:"center"}}>
                    //       {r.invoiceAmount}
                    //       {/* {Number(
                    //         Number(invUnitPrice) * Number(finalNetWeight)
                    //       )?.toLocaleString(undefined, {
                    //         minimumFractionDigits: 2,
                    //         maximumFractionDigits: 2,
                    //       })} */}
                    //     </td>
                    //   </tr>
                    // );
                    return (
                      <tr key={index}>
                        {plantDetails?.modeOfExport === ModeOfExportEnum.FLIGHT ? (
  <td className="ta-b" style={{ textAlign: "center" }}>
    {r.marksAndNo}
  </td>
) : (totalContainersRowSpan-- === copiedContainerRowSpan && (
                          <td
                            className="ta-b"
                            rowSpan={totalContainersRowSpan + 1} // Ensure correct row span
                          >
                            <b>Container No:</b> {plantDetails?.saleOrderItems[0]?.containerNo}
                            <br />
                            <hr
                              style={{
                                border: 'none',
                                borderBottom: '2px solid #000',
                                margin: 0,
                                marginBottom: '-1px',
                              }}
                            />
                            <b>Seal No:</b> {plantDetails?.saleOrderItems[0]?.linearSelaNo}
                          </td>
                        ))}
                    
                        {prodRowSpan-- === containerProductLevelRowSpan.get(prodIndex) && (
                          <td
                            className="ta-b"
                            rowSpan={containerProductLevelRowSpan.get(prodIndex)}
                            colSpan={plantDetails?.isItem ? 2 : 3}
                            style={{ textAlign: "center" }}
                          >
                            {g.productDescription}
                          </td>
                        )}
                    
                        {plantDetails?.isItem && <td className="ta-b">{r.itemCode}</td>}
                    
                        <td className="ta-b" style={{ textAlign: "center" }}>
                          {r.minGrade}/{r.maxGrade}
                          {r.grade && (
                            <>
                              <br />({r.grade})
                            </>
                          )}
                        </td>
                    
                        <td className="ta-b" style={{ textAlign: "center" }}>{r.noOfCases}</td>
                    
                        <td className="ta-b" style={{ textAlign: "center" }}>
                          {finalNetWeight
                            ? Number(finalNetWeight).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "0.00"}
                        </td>
                    
                        <td className="ta-b" style={{ textAlign: "center" }}>
                          {parseFloat(invUnitPrice).toFixed(2)}
                        </td>
                    
                        <td className="ta-b" style={{ textAlign: "center" }}>
                          {Number(r.invoiceAmount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    );
                    
                  });
                })
              }
              {/* <tr>
                    <td className={'ta-b'}><b>SEAL No:</b>{plantDetails?.saleOrderItems[0]?.linearSelaNo}</td>
                    </tr> */}
              <tr>
                <td className={'ta-b'}>
                  <b>Net Weight</b>
                </td>

                
                {conditionRes?.[0]?.lbParam == true ? (
                  <td className={'ta-b'}>
                    { Math.round(netWeightInLbs)?.toFixed(2)
                      }
                    (LBS)
                  </td>
                ) : (
                  <td className={'ta-b'}></td>
                )}
                <td className={'ta-b'}>
                  { Number(netWeightInKgs)?.toFixed(2) }
                  (KGS)
                </td>
                {conditionRes?.[0]?.isHsn === true ? (
                  <td
                    className={'ta-b'}
                    rowSpan={conditionRes?.[0]?.frozenWeight === true ? 3 : 2}
                  >
                    <b>HSN Code: </b>
                    {/* {plantDetails?.saleOrderItems?.map((item) => {
                      return (
                        <>
                          <span>{item.foodTypeHsnCode}</span>
                          <br />
                        </>
                      );
                    })} */}
                    {[...new Set(plantDetails?.saleOrderItems?.map((item) => item.foodTypeHsnCode))].map((foodTypeHsnCode) => {
  return (
    <>
      <span>{foodTypeHsnCode}</span>
      <br />
    </>
  );
})}
                  </td>
                ) : (
                  <td
                    className={'ta-b'}
                    rowSpan={conditionRes?.[0]?.frozenWeight === true ? 3 : 2}
                  ></td>
                )}
                {conditionRes[0]?.blNo === true ? (
                  <>
                    <td className={'ta-b'}>
                      <b>Total</b>
                    </td>
                    <td className={'ta-b'} style={{textAlign:"center"}}>{totalCases}</td>
                    <td className={'ta-b'} style={{textAlign:"center"}}>
                      {totalLbWeight
                        ? Number(totalLbWeight)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : 0}
                    </td>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'} style={{textAlign:"center"}}>
                      {Number(totalAmount)?.toLocaleString(
                        CrrencySymbols.find(
                          (item) =>
                            item.name ==
                            plantDetails?.saleOrderItems[0]?.currencyDetails
                        )?.locale,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )}
                    </td>
                  </>
                ) : (
                  <>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'}></td>
                  </>
                )}
              </tr>

              {conditionRes?.[0]?.frozenWeight === true ? (
                <tr>
                  <td className={'ta-b'}>
                    <b>Frozen Weight</b>
                  </td>
                 
                  {conditionRes?.[0]?.lbParam == true ? (
                    <td className={'ta-b'}>
                      {Math.round(
                        frozenWeightInKg / 0.454
                      )?.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                      (LBS)
                    </td>
                  ) : (
                    <td className={'ta-b'}></td>
                  )}
                   <td className={'ta-b'}>
                    {Math.round(frozenWeightInKg)?.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    (KGS)
                  </td>
                  {conditionRes?.[0]?.blNo == true ? (
                    <></>
                  ) : (
                    <>
                      <td className={'ta-b'}></td>
                      <td className={'ta-b'}></td>
                      <td className={'ta-b'}></td>
                      <td className={'ta-b'}></td>
                    </>
                  )}
                </tr>
              ) : (
                ''
              )}
              
              <tr>
                <td className={'ta-b'}>
                  <b>Gross Weight</b>
                </td>

                
                {conditionRes?.[0]?.lbParam == true ? (
                  <td className={'ta-b'}>
                    {Math.round(
                      grossWeightInKg / 0.454
                    )?.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    (LBS)
                  </td>
                ) : (
                  <td className={'ta-b'}></td>
                )}
                <td className={'ta-b'}>
                  {Math.round(grossWeightInKg)?.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  (KGS)
                </td>
                {conditionRes?.[0]?.blNo == true ? (
                  <>
                    <td
                      className={'ta-b'}
                      colSpan={5}
                      rowSpan={conditionRes?.[0]?.frozenWeight === true ? 2 : 1}
                    >
                      <b>BILL OF LADING NO:</b>
                      {plantDetails?.saleOrderItems[0]?.billOfLadingno}
                    </td>
                  </>
                ) : (
                  <>
                    <td className={'ta-b'}>
                      <b>Total</b>
                    </td>
                    <td className={'ta-b'}>{totalCases}</td>
                    <td className={'ta-b'}>
                      {totalLbWeight
                        ? Number(totalLbWeight)?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : 0}
                    </td>
                    <td className={'ta-b'}></td>
                    <td className={'ta-b'}>
                      {Number(totalInvoiceAmount)?.toLocaleString(
                        CrrencySymbols.find(
                          (item) =>
                            item.name ==
                            plantDetails?.saleOrderItems[0]?.currencyDetails
                        )?.locale,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )}
                    </td>
                  </>
                )}
              </tr>
              <tr>
                <td
                  className={'ta-b'}
                  colSpan={9}
                  style={{
                    textAlign: 'center',
                    }}
                >
                  {' '}
                  ( <b> TOTAL U.S. Dollars : </b>
                    {totalInvoiceAmount !== undefined 
                    ? (totalInvoiceAmount === 0 
                    ? "ZERO" 
                   : toWords.convert(totalInvoiceAmount, { currency: true }).toUpperCase())
                   : ''}
                  {/* {totalAmount
                    ? toWords
                        .convert(totalAmount, { currency: true })
                        .toUpperCase()
                    : ''}{' '} */}
                  ){' '}
                </td>
              </tr>
              <tr>
              <td
                  className={'ta-b'}
                  colSpan={10}
                >
                  <b style={{ textAlign: 'left' }}>PACKED & PROCESSED BY : </b>
                  <h4 style={{ display: 'inline', textAlign: 'left' }}>
                    {processingData?.company ? processingData?.company : ''}
                  </h4>
                  <br />
                  {processingData?.addressOne ? processingData?.addressOne + ',' : ''}
          <br />
          {processingData?.addressTwo
            ? processingData?.addressTwo + ' - ' + processingData?.postalCode
            : ''}
          <br />
          {processingData?.state + ', ' + processingData?.country}
                  <br />
                  <b style={{ textAlign: 'center' }}>APPROVAL NUMBER :</b>
                  {exportersPlant?.approvalNum}{' '}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {exportersPlant?.feiNumber ? (
                    <>
                      <b style={{ textAlign: 'center' }}>USFDA REGN NO:</b>
                      {exportersPlant?.consigneefdaRegNumber}
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
              {conditionRes?.[0]?.freightRate === true ? (
                <tr>
                  <td
                    className={'ta-b'}
                    colSpan={5}
                    style={{
                      textAlign: 'right',
                      }}
                  >
                    <b>PREPAID FREIGHT IN USD:</b>
                  </td>
                  <td
                    className={'ta-b'}
                    colSpan={4}
                    style={{
                      textAlign: 'left',
                     }}
                  >
                    <b>
                      {plantDetails?.saleOrderItems[0]?.currencyDetails +
                      ' : ' +
                      plantDetails?.freightCharges
                        ? plantDetails?.freightCharges
                        : 0}
                    </b>
                  </td>
                </tr>
              ) : (
                ''
              )}
              {conditionRes?.[0]?.cvd === true &&
              conditionRes?.[0]?.freightRate === true ? (
                <tr>
                  <td
                    className={'ta-b'}
                    colSpan={5}
                    style={{
                      textAlign: 'right',
                      }}
                  >
                    <b>SUB TOTAL:</b>
                  </td>
                  <td
                    className={'ta-b'}
                    colSpan={4}
                    style={{
                      textAlign: 'left',
                      }}
                  >
                    <b>{Number(subTotal).toFixed(2)}</b>
                  </td>
                </tr>
              ) : (
                ''
              )}
              {/* <tr>
                <td
                  className={'ta-b'}
                  colSpan={5}
                  style={{
                    textAlign: 'right',
                    }}
                >
                  <b>ANTI DUMPING DUTY @1.35%:</b>
                </td>
                <td
                  className={'ta-b'}
                  colSpan={4}
                  style={{
                    textAlign: 'left',
                     }}
                >
                  <b>{antiDumping ? Number(antiDumping).toFixed(2) : 0}</b>
                </td>
              </tr> */}
              {/* {conditionRes?.[0]?.cvd === true &&
              conditionRes?.[0]?.freightRate === true ? (
                <tr>
                  <td
                    className={'ta-b'}
                    colSpan={5}
                    style={{
                      textAlign: 'right',
                      }}
                  >
                    <b>CVD @ {cvdDetails.price}%:</b>
                  </td>
                  <td
                    className={'ta-b'}
                    colSpan={4}
                    style={{
                      textAlign: 'left',
                      }}
                  >
                    <b>{cvdVal ? Number(cvdVal).toFixed(2) : 0}</b>
                  </td>
                </tr>
              ) : (
                ''
              )} */}
                  {/* {conditionRes?.[0]?.cvd === true &&
              plantDetails?.deliveryTerms.includes('DDP') ? (
                <tr>
                  <td
                    className={'ta-b'}
                    colSpan={5}
                    style={{
                      textAlign: 'right',
                      }}
                  >
                    <b>MPF & HARBOUR MAINTAINCE @ {mpfDetails}%:</b>
                  </td>
                  <td
                    className={'ta-b'}
                    colSpan={4}
                    style={{
                      textAlign: 'left',
                      }}
                  >
                    <b>{mpfVal ? Number(mpfVal).toFixed(2) : 0}</b>
                  </td>
                </tr>
              ) : (
                ''
              )} */}
               {/* {conditionRes?.[0]?.cvd === true &&
              plantDetails?.deliveryTerms.includes('DDP') ? (
                <tr>
                  <td
                    className={'ta-b'}
                    colSpan={5}
                    style={{
                      textAlign: 'right',
                      }}
                  >
                    <b>RECIPROCAL TARIFF @ {tariffDetails}%:</b>
                  </td>
                  <td
                    className={'ta-b'}
                    colSpan={4}
                    style={{
                      textAlign: 'left',
                      }}
                  >
                    <b>{tariffVal ? Number(tariffVal).toFixed(2) : 0}</b>
                  </td>
                </tr>
              ) : (
                ''
              )} */}
                {(() => {
  const isDDP = plantDetails?.deliveryTerms.includes('DDP');
  const hasAntiDumping = conditionRes?.[0]?.antiDumping === true && conditionRes?.[0]?.freightRate === true;
  const hasCVD = conditionRes?.[0]?.cvd === true && conditionRes?.[0]?.freightRate === true;

  // Calculate combined percentages if DDP is present
  const combinedPercentage = isDDP
    ? 1.35 + Number(cvdDetails || 0) + Number(mpfDetails || 0) + Number(tariffDetails || 0)
    : 0;

  const subTotalValue = Number(subTotal || 0);
  const taxOnSubtotal = (subTotalValue * combinedPercentage);
  const taxBase = 100 + combinedPercentage;
  const totalvalue=taxOnSubtotal/taxBase

  return (
    <>
      { conditionRes?.[0]?.antiDumping === true && conditionRes?.[0]?.freightRate === true && (
        <tr>
          <td className="ta-b" colSpan={5} style={{ textAlign: 'right' }}>
            <b>ANTI DUMPING DUTY @1.35%:</b>
          </td>
          <td
            className="ta-b"
            colSpan={isDDP ?2:4}
            rowSpan={isDDP ? 4 : 1}
            style={{ textAlign: 'left', verticalAlign: isDDP ? 'middle' : 'top', }}
          >
            <b>
            {isDDP
      ? `${subTotalValue} * ${combinedPercentage} / ${taxBase}`
      : antiDumping
      ? Number(antiDumping).toFixed(2)
      : 0}
            </b>
          </td>
          {isDDP
      ? <>
      <td  className="ta-b"
            colSpan={2}
            rowSpan={isDDP ? 4 : 1}
            style={{ textAlign: 'left', verticalAlign: isDDP ? 'middle' : 'top', }}>
            <b>{totalvalue.toFixed(2)}</b>
            </td>
      </>
      : <></>}
        </tr>
      )}

      {conditionRes?.[0]?.cvd === true && conditionRes?.[0]?.freightRate === true && (
        <tr>
          <td className="ta-b" colSpan={5} style={{ textAlign: 'right' }}>
            <b>CVD @ {cvdDetails}%:</b>
          </td>
          {!isDDP && (
            <td className="ta-b" colSpan={4} style={{ textAlign: 'left' }}>
              <b>{cvdVal ? Number(cvdVal).toFixed(2) : 0}</b>
            </td>
            
          )}
        </tr>
      )}

      {conditionRes?.[0]?.cvd === true && plantDetails?.deliveryTerms.includes('DDP') && (
        <tr>
          <td className="ta-b" colSpan={5} style={{ textAlign: 'right' }}>
            <b>MPF & HARBOUR MAINTAINCE @ {mpfDetails}%:</b>
          </td>
          {!plantDetails?.deliveryTerms.includes('DDP') && (
            <td className="ta-b" colSpan={4} style={{ textAlign: 'left' }}>
              <b>{mpfVal ? Number(mpfVal).toFixed(2) : 0}</b>
            </td>
          )}
        </tr>
      )}

      {conditionRes?.[0]?.cvd === true && plantDetails?.deliveryTerms.includes('DDP') && (
        <tr>
          <td className="ta-b" colSpan={5} style={{ textAlign: 'right' }}>
            <b>RECIPROCAL TARIFF @ {tariffDetails}%:</b>
          </td>
          {!plantDetails?.deliveryTerms.includes('DDP') && (
            <td className="ta-b" colSpan={4} style={{ textAlign: 'left' }}>
              <b>{tariffVal ? Number(tariffVal).toFixed(2) : 0}</b>
            </td>
          )}
        </tr>
      )}

      {/* <tr>
        <td className="ta-b" colSpan={5} style={{ textAlign: 'right' }}>
          <b>SUB TOTAL:</b>
        </td>
        <td className="ta-b" colSpan={4} style={{ textAlign: 'left' }}>
          <b>{Number(subTotal).toFixed(2)}</b>
        </td>
      </tr> */}
    </>
  );
})()}
              <tr>
                <td
                  className={'ta-b'}
                  colSpan={5}
                  style={{
                    textAlign: 'right',
                     }}
                >
                  <b>FOB VALUE IN USD :</b>
                </td>
                <td
                  className={'ta-b'}
                  colSpan={4}
                  style={{
                    textAlign: 'left',
                     }}
                >
                  <b>{fob ? Number(fob).toFixed(2) : 0}</b>
                </td>
              </tr>
              {plantDetails.remarks != null ? (
                <tr>
                  <td
                    className={'ta-b'}
                    colSpan={9}
                    style={{ fontSize: '16px', paddingTop: '20px' }}
                  >
                    <p>
                      <b>{plantDetails.remarks}</b>
                    </p>
                  </td>
                </tr>
              ) : (
                ''
              )}
              {/* <tr>
              <td
                  colSpan={9}
                  style={{
                    textAlign: 'left',
                    fontSize: '14px',
                    paddingTop: '20px',
                    border: '1px solid black',
                    borderCollapse: 'collapse',
                    textTransform: 'uppercase',
                  }}
                >
                  <b> Q CERTIFICATE NO: </b>
                  {plantDetails?.qCertificateNo}
                </td>
              </tr> */}
              <tr>
                <td
                  className={'ta-b'}
                  colSpan={9}
                  style={{
                    textAlign: 'left',
                    }}
                >
                  
                    <b>BANK DETAILS:</b>
                  
                  <br />
                  <b>NAME OF ACCOUNT:</b>
                  {plantDetails?.bankInfo?.[0]?.displayName
                      ? plantDetails.bankInfo[0].displayName
                      : ''}
                  <br />
                  <b>BANK NAME:</b>
                  {plantDetails?.bankInfo?.[0]?.bankName
                    ? plantDetails.bankInfo[0].bankName
                    : ''}
                  <br />
                  <b>BRANCH:</b>
                  {plantDetails?.bankInfo?.[0]?.branchName
                    ? plantDetails.bankInfo[0].branchName
                    : ''}
                  <br />
                  <b>CURRENT ACCOUNT NO:</b>
                  {plantDetails?.bankInfo?.[0]?.bankAcc
                    ? plantDetails.bankInfo[0].bankAcc
                    : ''}
                  <br />
                  <b>SWIFT CODE:</b>
                  {plantDetails?.bankInfo?.[0]?.swiftCode
                    ? plantDetails.bankInfo[0].swiftCode
                    : ''}
                  <br />
                  <b>IFSC CODE:</b>
                  {plantDetails?.bankInfo?.[0]?.ifscCode
                    ? plantDetails.bankInfo[0].ifscCode
                    : ''}
                  <br />
                  <b>BANK ADRESS:</b>
                  {plantDetails?.bankInfo?.[0]?.bankAddress
                    ? plantDetails.bankInfo[0].bankAddress
                    : ''}
                  <br />
                </td>
              </tr>
              
              <tr>
                <td colSpan={4} id="inputText">
                  {' '}
                  <div style={{paddingLeft:"8px"}}>
                    <b>Declaration : </b>
                  </div>
                  <div style={{paddingLeft:"8px"}}>
                    We declare that the invoice shows the actual price of goods
                    described
                  </div>
                  <div style={{paddingLeft:"8px"}}>
                    and all particulars are true and correct . "This Product has
                    not been{' '}
                  </div>
                  <div style={{paddingLeft:"8px"}}>
                    previously refused by any other country prior to the
                    shipment to USA,"
                  </div>
                </td>
              
                <td colSpan={5} className={'ta-b'} style={{textAlign:"center"}}>
                  {/* <div className='stamp-and-print'> */}
                  for  <b>{plantDetails.invoicedPlant.company}</b>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <b>
                    <b>AUTHORISED SIGNATORY</b>
                  </b>
                  {/* </div> */}
                </td>
              </tr>
              {/* <tr>
                <td className={'ta-b'} colSpan={4} style={{ textAlign: 'center' }}>
                  Total
                </td>
                <td colSpan={1} className={'ta-b'} style={{ textAlign: 'right' }}><b>
                  {totalCases}</b>
                </td>
                <td style={{ textAlign: 'right' }} className={'ta-b'}><b>
                  {(totalLbWeight) ? Number(totalLbWeight).toLocaleString(undefined, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : 0}</b>
                </td>
                <td className={'ta-b'} style={{ borderTop: '0px' }}></td>
                <td className={'ta-b'} style={{ borderTop: '0px' }}></td>
              </tr> */}

              {/* <tr>
                <td colSpan={5} >
                  Amount chargeable <br /> (in words):  <b> U.S {(totalAm) ? (toWords.convert(totalAm, { currency: true }).toUpperCase()) : ""}</b>
                </td>
                <td colSpan={2} style={{ textAlign: 'left', borderBottom: '0px' }}>
                  <b>Total USD</b>
                </td>
                <td style={{ textAlign: 'right' }} className={'ta-b'}><b>
                 
                  {Number(totalAm).toLocaleString(CrrencySymbols.find(item => item.name == plantDetails?.saleOrderItems[0]?.currencyDetails).locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </b></td>
              </tr>
              <br></br>
              <br></br>
              <br></br>
              <br></br>


              <tr>
                <td style={{ width: '20%' }} className={'ta-b'}></td>
                {
                  plantDetails.country === 'INDIA' ? <>
                    <td style={{ textAlign: 'center', width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                      <h4><b>IN LBS</b></h4>
                    </td>
                    <td style={{ textAlign: 'center', width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                      <h4><b>IN KGS</b></h4>
                    </td>
                  </> : <>
                    <td style={{ textAlign: 'center', width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                      <h4><b>IN LBS</b></h4>
                    </td>
                    <td style={{ textAlign: 'center', width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                      <h4><b>IN KGS</b></h4>
                    </td>
                  </>
                }

                <td style={{ width: '30%' }}></td>
                <td className={'ta-b'} colSpan={4} style={{ width: '10%', borderTop: '0px', borderLeft: '0px', borderBottom: '0px' }}></td>
              </tr>
              <tr>
                <td style={{ width: '20%', borderBottom: '0px' }} className={'ta-b'}>
                  {' '}
                  <b>TOTAL NET WT:{' '}</b>
                </td>
                {
                  plantDetails.country === 'INDIA' ? <>
                    <td style={{ textAlign: 'right', width: '20%', borderTop: '0px', borderBottom: '0px' }} className={'ta-b'}>
                      <h4>{(Number((totalLbWeight / 0.454))).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                    </td>
                    {console.log(Number(totalLbWeight / 0.454).toFixed(3))}
                    <td style={{ textAlign: 'right', width: '20%', borderTop: '0px', borderBottom: '0px' }} className={'ta-b'}>
                   
                      <h4>{(totalLbWeight).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                    </td>

                  </> :
                    <>
                      <td style={{ textAlign: 'right', width: '20%', borderTop: '0px', borderBottom: '0px' }} className={'ta-b'}>
                        <h4>{(totalLbWeight).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                      </td>
                      <td style={{ textAlign: 'right', width: '20%', borderTop: '0px', borderBottom: '0px' }} className={'ta-b'}>
                        <h4>{(Number((totalLbWeight * 0.454))).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                      </td>
                    </>

                }

                <td colSpan={3} style={{ width: '30%', textAlign: 'center' }}>
                  TOTAL NO. OF MASTER CARTONS:
                </td>
                <td className={'ta-b'} colSpan={2} style={{ textAlign: 'right', width: '10%', borderTop: '0px', borderLeft: '0px', borderBottom: '0px' }}>
                  <h4><b>{totalCases}</b></h4>
                </td>


              </tr>
              <tr>
                <td style={{ width: '20%', borderTop: '0px' }} className={'ta-b'}>
                  {' '}
                  <b> TOTAL GROSS WT:</b>
                </td>
                <td style={{ textAlign: 'right', width: "20%", borderTop: '0px' }} className={'ta-b'}>
                  <h4>{Math.round((totalGrossWeight / 0.454) ? (totalGrossWeight / 0.454) : 0).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                </td>
                <td style={{ textAlign: 'right', width: '20%', borderTop: '0px' }} className={'ta-b'}>
                  <h4>{(Math.round(totalGrossWeight ? totalGrossWeight : 0)).toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</h4>
                </td>
                <td colSpan={3} style={{ width: '30%', textAlign: 'center' }}>
                  TOTAL AMOUNT (IN {plantDetails?.saleOrderItems[0]?.currencyDetails}):
                </td>
                <td className={'ta-b'} colSpan={2} style={{ textAlign: 'right', width: '10%', borderTop: '0px', borderLeft: '0px', borderBottom: '0px' }}  >
                  <h4>
                    <b>{Number(totalAm).toLocaleString(CrrencySymbols.find(item => item.name == plantDetails?.saleOrderItems[0]?.currencyDetails).locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                  </h4>
                </td>
              </tr> */}
              {/* </table>
            <table style={{width:'100%',tableLayout:'fixed'}}> */}

              {/* <tr>
                <td colSpan={4} id='inputText'><b>Declaration :</b>
                  <TextArea style={{ outline: 'none', border: 'none' }} rows={3} contentEditable={true} defaultValue={defaultDeclaration}
                    onChange={(evt) => handleRemarks(evt)}
                  ></TextArea>
                </td>
                <td colSpan={4} className={'ta-b'}>
                  <b>Signature and Date For :</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
                  <h4>{plantDetails.invoicedPlant.company}</h4>

                  <br />
                  <h4>AUTHORISED SIGNATORY</h4>
                </td>
              </tr> */}
            </table>
          </body>
        </html>
      ) : (
        <Card
          title={
            <span
              style={{
                color: 'black',
                borderColor: 'black',
                borderStyle: 'initial',
                height: '100',
              }}
            >
              Export Invoice
            </span>
          }
          style={{ textAlign: 'center' }}
          headStyle={{ backgroundColor: '#69c0ff' }}
        >
          <span style={{ paddingTop: '10px', textAlign: 'center' }}>
            <Spin />
          </span>
        </Card>
      )}
    </div>
  );
}

export default CommonInvoice;
